import React from 'react';
import styled from 'styled-components';
import magnifier from '../assets/icons/magnifier.svg';

export default function SearchForm({
	value,
	inputId,
	onChange,
	width = '100%',
	placeholder,
}) {
	return (
		<Container className='search-form' width={width}>
			<MagnifierContainer />
			<Input
				type='text'
				id={inputId}
				name={inputId}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
			/>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	align-items: center;
	background: rgb(var(--input-bg-color));
	border-radius: 8px;
	padding: 10px 17px;
	width: ${props => props.width};
`;

const Input = styled.input`
	color: var(--third-text-color);
	background: none;
	border: none;
	width: 100%;
	font-family: 'NotoSansMd';
	font-weight: 500;
	font-size: 15px;
`;

const MagnifierContainer = styled.div`
	background: url(${magnifier});
	background-position: center;
	background-repeat: no-repeat;
	width: 20px;
	height: 20px;
	margin-right: 5px;
`;
